<template>
  <v-card flat>
    <v-col cols="12" class="px-0">
      <v-btn color="primary" icon @click="beforeLeave">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="text-h6 mr-2" style="vertical-align: middle">
        {{ $t('message.pandaVideoPIP') }}
      </span>
    </v-col>
    <v-row no-gutters class="py-0 px-2">
      <v-col cols="12">
        <v-card flat>
          <span v-html="$t('message.pages.video.messagePIP')"></span>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="pt-10 px-0">
          <v-col cols="12">
            <v-card flat>
              <h3
                class="font-weight-medium white--text"
                :class="{
                  'neutral--text text--darken-1': !$vuetify.theme.dark,
                }"
              >
                {{ $t('message.settings') }}
              </h3>
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters class="pt-5 px-0">
          <v-col cols="8">
            <v-card flat>
              <h3
                class="font-weight-regular white--text"
                :class="{
                  'neutral--text text--darken-1': !$vuetify.theme.dark,
                }"
              >
                {{ $t('message.pages.video.openConfigPIP') }}
              </h3>
              <span v-html="$t('message.pages.video.openConfigPIPText')"></span>
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-row justify="end" class="pt-8 pr-4">
              <base-btn type="secondary" @click="openEmbed">
                <v-icon size="16" class="mr-2">mdi-open-in-new</v-icon
                >{{ $t('message.pages.video.openButton') }}
              </base-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row no-gutters class="pt-10 px-0">
          <v-col cols="12">
            <v-card flat>
              <h3
                class="font-weight-medium white--text"
                :class="{
                  'neutral--text text--darken-1': !$vuetify.theme.dark,
                }"
              >
                {{ $t('message.pages.video.demoPIP') }}
              </h3>
              <img
                class="pt-2"
                src="../../../assets/demo-scrollfollow.gif"
                width="70%"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  name: 'VideoPlayerPIP',
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  data: () => ({}),
  async mounted() {},
  methods: {
    beforeLeave() {
      this.handleBack()
    },
    openEmbed() {
      this.$root.$emit('openEmbedModal')
    },
  },
}
</script>
<style></style>
